var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("ValidationObserver", {
        ref: "orderCollectionOfFeesFormObserver",
        attrs: { tag: "div" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "form",
                  {
                    staticClass: "row add-person",
                    class: { "is-waiting": _vm.isWaiting },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.add)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c("h1", { staticClass: "add-person__title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isOperator
                                ? "Dodaj operatora"
                                : "Dodaj organizatora"
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-12 col-lg-4" }, [
                      _c(
                        "div",
                        { staticClass: "add-person__box" },
                        [
                          _c("p", { staticClass: "add-person__box-label" }, [
                            _vm._v(" E-mail "),
                          ]),
                          _c("ValidationProvider", {
                            staticClass: "scroll-margin",
                            attrs: { name: "email", rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("base-input-text", {
                                        staticClass: "add-person__input",
                                        attrs: {
                                          error:
                                            _vm.apiErrors.email || errors[0],
                                          label: "E-mail",
                                        },
                                        on: {
                                          "update:error": function ($event) {
                                            return _vm.$set(
                                              _vm.apiErrors.email || errors,
                                              0,
                                              $event
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.email,
                                          callback: function ($$v) {
                                            _vm.email = $$v
                                          },
                                          expression: "email",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-12 col-lg-4" }, [
                      _c(
                        "div",
                        { staticClass: "add-person__box" },
                        [
                          _c("p", { staticClass: "add-person__box-label" }, [
                            _vm._v(" Nazwa "),
                          ]),
                          _c("ValidationProvider", {
                            staticClass: "scroll-margin",
                            attrs: { name: "name", rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("base-input-text", {
                                        staticClass: "add-person__input",
                                        attrs: {
                                          label: "Nazwa",
                                          error:
                                            _vm.apiErrors.name || errors[0],
                                        },
                                        on: {
                                          "update:error": function ($event) {
                                            return _vm.$set(
                                              _vm.apiErrors.name || errors,
                                              0,
                                              $event
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.name,
                                          callback: function ($$v) {
                                            _vm.name = $$v
                                          },
                                          expression: "name",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-12 col-lg-4" }, [
                      _c(
                        "div",
                        { staticClass: "add-person__box" },
                        [
                          _c("p", { staticClass: "add-person__box-label" }, [
                            _vm._v(" Telefon "),
                          ]),
                          _c("ValidationProvider", {
                            staticClass: "scroll-margin",
                            attrs: { name: "phone", rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("base-input-text", {
                                        staticClass: "add-person__input",
                                        attrs: {
                                          label: "Telefon",
                                          error:
                                            _vm.apiErrors.phone || errors[0],
                                        },
                                        on: {
                                          "update:error": function ($event) {
                                            return _vm.$set(
                                              _vm.apiErrors.phone || errors,
                                              0,
                                              $event
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.phone,
                                          callback: function ($$v) {
                                            _vm.phone = $$v
                                          },
                                          expression: "phone",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "row add-person__buttons" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-lg-2" },
                          [
                            _c(
                              "base-button",
                              {
                                staticClass: "add-person__btn",
                                attrs: { btn2: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("close")
                                  },
                                },
                              },
                              [_vm._v(" Anuluj ")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12 col-lg-2" },
                          [
                            _c(
                              "base-button",
                              {
                                staticClass: "add-person__btn",
                                attrs: { btn1: "", loading: _vm.isWaiting },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.add)
                                  },
                                },
                              },
                              [_vm._v(" Dodaj ")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }